import { render, staticRenderFns } from "./LinkHeader.vue?vue&type=template&id=244a7893"
import script from "./LinkHeader.vue?vue&type=script&lang=js"
export * from "./LinkHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports